import React from 'react';

import t from "../../../lib/I18n";
import SmartcardInfoModal from './SmarcardInfoModal';
import {Tutorials} from "../../../constants/AppConstants";
import Tutorial from "../../general/Tutorial";

class SmartcardInfo extends React.PureComponent {

    _handleClick = () => {
        this.setState({ modalOpen: true });
    };

    state = {
        modalOpen: false,
    };

    render () {
        const { user, smartcard, enableSmartcardTutorial } = this.props;

        return (
            <section className="smartcard-info-modal">
                <span className="smartcard-info-modal__cta" onClick={ this._handleClick }>
                    { t('booking.smartcard.info') }
                    <i className="otrl otrl-info smartcard-info-modal__cta__icon" />
                </span>
                {this.state.modalOpen &&
                    <SmartcardInfoModal
                        onClose={ () => this.setState({ modalOpen: false }) }
                    />
                }
                {user.isLoggedIn() && smartcard && (smartcard.isPending() || smartcard.isActive()) && enableSmartcardTutorial &&
                    <Tutorial name={ Tutorials.SMARTCARD }/>
                }
            </section>
        );
    }

}


export default SmartcardInfo;



// WEBPACK FOOTER //
// ./src/components/search/smartcard/SmartcardInfo.js